module.exports = __webpack_public_path__ + "img/robot-delivery-engineer.b90e8cc1.png";